import { APIResponse, APIResponseDtoImpl } from '../../apiresponse';


export interface BuyToneResponse extends APIResponse
{
}


export class BuyToneResponseDtoImpl extends APIResponseDtoImpl implements BuyToneResponse
{
   
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/tune/buytune/buytoneresponse.tsx